<template>
  <div class="">
     <div v-if="params.data.assignment_type_id==3" style="margin: 0;" class="inline cstm-status-badge" :class="reportStatus[params.value-1].status.toLowerCase()">
     {{ params.value==1?getStatus():reportStatus[params.value-1].status}}
    </div>
    <div v-else style="margin: 0;" class="inline cstm-status-badge" :class="statusArray[params.value-1].status.toLowerCase()">
     {{ statusArray[params.value-1].status}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'CellRendererStatus',
  data () {
    return {
      reportStatus:[
        {
          id:1,
          status:'Assigned'},
        {
          id:2,
          status:'Filled In'},
        {
          id:3,
          status:'Submitted'},
        {
          id:4,
          status:'Completed'},
        {
          id:5,
          status:'Delayed'}
      ],
      statusArray:[
        {
          id:1,
          status:'Assigned'},
        {
          id:2,
          status:'Received'},
        {
          id:3,
          status:'Marked'},
        {
          id:4,
          status:'Completed'},
        {
          id:5,
          status:'Delayed'},
        {
          id:6,
          status:'Missed Deadline'}
      ]
    }
  },
  mounted () {
    // console.log(this.params.data)
  },
  methods: {
    getStatus () {
      const userId = JSON.parse(localStorage.getItem('userInfo')).id
      if (this.params.data.teacher.id === userId) {
        return 'Pending'
      }
      return 'Assigned'
    }
  }
}
</script>
